import React from 'react';

/**
 * Componente de Error Boundary para capturar erros nos componentes filhos
 * e exibir uma interface de fallback amigável ao invés de quebrar toda a UI
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Atualiza o state para exibir a UI de fallback
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Grava informações sobre o erro
    console.error('Erro capturado por ErrorBoundary:', error, errorInfo);
    this.setState({ errorInfo });

    // Aqui você pode enviar o erro para um serviço de monitoramento
    // como Sentry, LogRocket, etc.
  }

  render() {
    if (this.state.hasError) {
      // UI de fallback personalizada
      return (
        <div className="bg-white p-6 rounded-lg shadow-sm">
          <div className="border-l-4 border-orange-500 p-4 bg-orange-50 mb-4">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-orange-500 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <h3 className="text-lg font-medium text-orange-800">
                Erro ao carregar dados da propriedade
              </h3>
            </div>
            <p className="text-sm text-orange-700 mt-2">
              Ocorreu um problema ao processar os dados desta propriedade. Nossa equipe foi
              notificada.
            </p>
          </div>

          {this.props.showErrorDetails && (
            <div className="mt-4 p-4 bg-gray-50 rounded border border-gray-200">
              <h4 className="text-sm font-medium text-gray-700 mb-2">Detalhes técnicos:</h4>
              <pre className="text-xs overflow-auto p-2 bg-gray-100 rounded">
                {this.state.error && this.state.error.toString()}
              </pre>
            </div>
          )}

          <div className="mt-4">
            <button
              onClick={() => this.setState({ hasError: false })}
              className="px-4 py-2 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
            >
              Tentar novamente
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
